module.exports = __webpack_public_path__ + "static/media/gradient-mask.a55786bd.png";